// Source: https://www.gatsbyjs.org/docs/use-static-query/
import {useStaticQuery, graphql} from 'gatsby';
import {useIntl} from 'react-intl';

import {useLocale, Locale} from './RootProvider/LocaleContext';
import {getNodesByLocale} from './localeUtils/getNodesByLocale';

interface MenuItemProps {
  url: string;
  node_locale: Locale;
  label: string;
  isPrimary: boolean;
  ordering: number;
  column: string;
}

const useContentfulHeaderLinks = (): MenuItemProps[] => {
  const locale = useLocale();
  const {locale: language} = useIntl();

  const query = useStaticQuery(
    graphql`
      query HeaderMenu {
        allContentfulHeaderMenu {
          nodes {
            url
            node_locale
            label
            isPrimary
            ordering
            column
            displayOnLocale
          }
        }
      }
    `
  );

  const menuItems = getNodesByLocale<MenuItemProps>(query.allContentfulHeaderMenu.nodes, locale, language as Locale);

  return menuItems;
};

export default useContentfulHeaderLinks;
